import { createSelector } from '@reduxjs/toolkit';

import carsDataSelector from './data';

/**
 * Получить количество авто из запроса на получение автомобилей
 */
export const carsCountSelector = createSelector(
  carsDataSelector,
  carsData => carsData.data?.total,
);

export default carsCountSelector;
